export default __webpack_public_path__ + "static/royal_longsword-9469137dd32915621889e7f42e820e39.png";